import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import ProMeter from "../../../../components/UI/ProMeter";
import { track } from "../../../../helpers/track";
import { AppState } from "../../../../store/store";
import styles from "./ScoreFree.module.scss";

interface Props {
  userId: string;
}

const ScoreFree = ({ userId }: Props) => {
  const min = 400;
  const max = 850;
  const [score, setScore] = useState(min);
  const [mirror, setMirror] = useState(false);

  const handleClick = () => {
    const element = document.getElementById("dashboard_report");
    if (element) {
      element.scrollIntoView({ behavior: "smooth", block: "start" })
      const event = new CustomEvent("activateDashboardReport");
      element.dispatchEvent(event);
    }
    const properties = {
      date: +new Date,
    };
    track({ userId, event: "VIEW_SCORE_FREE", properties });
  }
  useEffect(() => {
    let intervalScore: NodeJS.Timer;
    intervalScore = setInterval(() => {
      if (mirror) setScore(score - 10);
      else setScore(score + 10);
      if (score === max) setMirror(true);
      if (score === min) setMirror(false);
    }, 50);
    return () => {
      clearInterval(intervalScore);
    };
  }, [score]);

  return (
    <div className={`eb-card ${styles.container}`} >
      <div>
        <p className={styles.title}>
          Puntaje de crédito
        </p>
        <p className={styles.text}>
          Descubre cómo te ven los bancos
        </p>
      </div>
      <div onClick={handleClick}>
        <ProMeter score={score} label="?" />
      </div>
      <div className={styles.ctaContent}>
        <Link to="/plan-consultas" className={styles.ctaLink}>
          <button className={styles.ctaButton}>
            Consulta tu puntaje
          </button>
        </Link>
      </div>
    </div>
  )
}
const mapStateToProps = (state: AppState) => ({
  userId: state.security.userId,
});

export default connect(mapStateToProps)(ScoreFree);